import CustomerTransactionListResourcePagingResultModel from '../../generated/types/model/resource/CustomerTransactionListResourcePagingResultModel';

export default class CustomerTransactionListResourcePagingResultViewModel extends CustomerTransactionListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
